import { useEffect } from "react";
import { toast } from "sonner";

const CAMPOS = ["oferta_chave", "oferta_dia", "oferta_desconto_unit", "oferta_acumula_cashback", "oferta_acumula_cupom"];

// "Vira junto com o dia": item que entrou no carrinho com uma oferta que não
// vale mais (dia virou, campanha desligou, limite usado em outro pedido) volta
// ao preço normal, com aviso. Sem o desconto unitário conhecido (pizza de dois
// sabores), o item sai do carrinho — melhor que cobrar um preço inventado.
export function useOfertasExpiradasNoCarrinho({ cart, setCart, ofertasDia }) {
  useEffect(() => {
    const estado = ofertasDia?.estado;
    if (!estado || estado === "carregando" || estado === "erro") return;
    const vigentes = estado === "ativo" ? ofertasDia.porChave : new Map();
    const expirou = (it) => it.oferta_chave
      && (it.oferta_dia !== ofertasDia.dia || !vigentes.has(it.oferta_chave));
    const expirados = (cart || []).filter(expirou);
    if (expirados.length === 0) return;
    setCart((prev) => prev.map((it) => {
      if (!expirou(it)) return it;
      if (it.oferta_desconto_unit == null) return null;
      const cheio = Math.round((Number(it.final_price || it.sale_price || 0) + Number(it.oferta_desconto_unit)) * 100) / 100;
      const novo = { ...it, final_price: cheio, sale_price: cheio };
      CAMPOS.forEach((k) => { delete novo[k]; });
      return novo;
    }).filter(Boolean));
    const nomes = expirados.map((it) => it.name).filter(Boolean).slice(0, 2).join(", ");
    toast.info(
      `Sua oferta${nomes ? ` em ${nomes}` : ""} expirou. O preço voltou ao normal no carrinho.`,
      { duration: 7000 },
    );
  }, [ofertasDia, cart, setCart]);
}
